import { Fragment, useEffect } from "react";
import { Popover, Transition } from "@headlessui/react";
import { FC } from "react";
import ClearDataButton from "../Buttons/ClearDataButton";
import ButtonSubmit from "./ButtonSubmit";
import { UserPlusIcon } from "@heroicons/react/24/outline";
import { GuestsObject } from "data/interfaces";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import { setGuests as setGuestsSearch } from "application/features/search/searchSlice";
import { setGuestsAdults, setGuestsChildren, setGuestsInfants, selectGuestsCount, selectGuests } from "application/features/guests/guestsSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Checkbox from "shared/Checkbox/Checkbox";

export interface GuestsInputProps {
  fieldClassName?: string;
  className?: string;
  buttonSubmitHref?: string;
  handleSubmit?: () => void;
  hasButtonSubmit?: boolean;
}

const GuestsInput: FC<GuestsInputProps> = ({
  fieldClassName = "[ nc-hero-field-padding ]",
  className = "[ nc-flex-1 ]",
  buttonSubmitHref = "/listing-stay-map",
  hasButtonSubmit = true,
  handleSubmit,
}) => {

  const guests: GuestsObject = useSelector(selectGuests);
  const totalGuests = useSelector(selectGuestsCount);
  const dispatch = useDispatch();

  const handleChangeData = (value: number, type: keyof GuestsObject) => {
    if (type === "adults") {
      dispatch(setGuestsAdults(value));
    }
    if (type === "children") {
      dispatch(setGuestsChildren(value));
    }
    if (type === "infants") {
      dispatch(setGuestsInfants(value));
    }
  };

  useEffect(() => {
    dispatch(setGuestsSearch(totalGuests));
  }, [totalGuests])

  return (
    <Popover className={`flex relative ${className}`}>
      {({ open }) => (
        <>
          <div
            className={`flex-1 z-10 flex items-center focus:outline-none ${open ? "nc-hero-field-focused" : ""
              }`}
          >
            <Popover.Button
              className={`relative z-10 flex-1 flex text-left items-center ${fieldClassName} space-x-3 focus:outline-none`}
              onClickCapture={() => document.querySelector("html")?.click()}
            >
              <div className="text-neutral-300 dark:text-neutral-400">
                <UserPlusIcon className="w-5 h-5 lg:w-7 lg:h-7" />
              </div>
              <div className="flex-grow">
                <span className="block xl:text-lg font-semibold">
                  {totalGuests || ""} Ospiti
                </span>
                <span className="block mt-1 text-sm text-neutral-400 leading-none font-light">
                  {totalGuests ? "Ospiti" : "Aggiungi ospiti"}
                </span>
              </div>

              {!!totalGuests && open && (
                <ClearDataButton
                  onClick={() => {
                    dispatch(setGuestsSearch({ adults: 0, children: 0, infants: 0 }));
                  }}
                />
              )}
            </Popover.Button>

            {/* BUTTON SUBMIT OF FORM */}
            {hasButtonSubmit && (
              <div className="pr-2 xl:pr-4">
                <ButtonSubmit handleOnClick={handleSubmit} />
              </div>
            )}
          </div>

          {open && (
            <div className="h-8 absolute self-center top-1/2 -translate-y-1/2 z-0 -left-0.5 right-1 bg-white dark:bg-neutral-800"></div>
          )}
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute right-0 z-10 w-full sm:min-w-[340px] max-w-sm bg-white dark:bg-neutral-800 top-full mt-3 py-5 sm:py-6 px-4 sm:px-8 rounded-3xl shadow-xl">
              <NcInputNumber
                className="w-full"
                defaultValue={guests.adults}
                onChange={(value) => handleChangeData(value, "adults")}
                max={10}
                min={1}
                label="Adulti"
                desc="Più di 13 anni"
              />
              <NcInputNumber
                className="w-full mt-6"
                defaultValue={guests.children}
                onChange={(value) => handleChangeData(value, "children")}
                max={4}
                label="Bambini"
                desc="2–12 anni"
              />

              <NcInputNumber
                className="w-full mt-6"
                defaultValue={guests.infants}
                onChange={(value) => handleChangeData(value, "infants")}
                max={4}
                label="Neonati"
                desc="0–2 anni"
              />

              <Checkbox
                name="company"
                label="Azienda"
                subLabel=""
                onChange={() => null}
                className="mt-6"
              />
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default GuestsInput;
